import cookies from 'js-cookie';
import {classList, dispatch, listen} from 'nuffjs';

let isPaused = null;
const autoplayCookieName = 'autoplayAnimations';
const autoplay = cookies.get(autoplayCookieName);
if (autoplay === '1') {
	isPaused = false;
} else if (autoplay === '0') {
	isPaused = true;
} else {
	const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
	isPaused = !mediaQuery || mediaQuery.matches;
}

const conf = {
	pausedClass: 'paused',
	eventName: 'animationsToggler:toggle',
};

class AnimationsToggler extends HTMLButtonElement {
	static conf = conf;
	firstConnectedCallback() {
		this.updateStatus();
		listen(this, 'click', this.onClick.bind(this));
		listen(document.body, conf.eventName, this.onToggle.bind(this));
	}

	onToggle(event) {
		this.updateStatus();
	}

	onClick(event) {
		this.blur();
		isPaused = !isPaused;
		cookies.set(autoplayCookieName, isPaused ? '0' : '1');
		this.triggerEvent();
	}

	updateStatus() {
		classList(this).toggle(conf.pausedClass, isPaused);
	}

	triggerEvent() {
		dispatch(this, conf.eventName, {
			bubbles: true,
			detail: {
				isPaused: isPaused,
			},
		});
	}

	isPaused() {
		return isPaused;
	}

	getEventName() {
		return conf.eventName;
	}
}

export {AnimationsToggler};
